import { Injectable } from '@angular/core';
import whatInput, { InputMethod } from 'what-input';

@Injectable({ providedIn: 'root' })
export class AccessibilityService {
  public isKeyboardUser = true;

  load() {
    const response = new Promise<void>((resolve) => resolve());
    if (typeof window === 'undefined') return response;

    const mouseDetection = (method: InputMethod) => {
      if (method === 'mouse' || method === 'touch') {
        this.isKeyboardUser = false;
        whatInput.unRegisterOnChange(mouseDetection);
      }
    };

    whatInput.registerOnChange(mouseDetection);
    return response;
  }
}

export const accessibilityServiceFactory = (accessibilityService: AccessibilityService) => {
  return () => {
    return accessibilityService.load();
  };
};
